module.exports = __webpack_public_path__ + "img/conductores_electricos.ff75c792.jpg";